module.exports = __webpack_public_path__ + "img/54fc4da.png";